<div class="flex flex-col w-full h-full">
    <div class="flex flex-row w-full">
        <!-- Drawer -->
        @if (!readonly) {
            <div class="w-72 flex-col flex-none">
                <div class="py-4 w-60 fixed bottom-0 block 2xl:hidden">
                    <ng-container *ngTemplateOutlet="typeList"></ng-container>
                </div>
                <div class="py-4 w-60 fixed hidden 2xl:block">
                    <ng-container *ngTemplateOutlet="typeList"></ng-container>
                </div>
            </div>
        }

        <!-- Content -->
        <div class="flex flex-col flex-auto overflow-hidden">
            @if (isLoading) {
                <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" mode="indeterminate">
                </mat-progress-bar>
            }
            <!-- Filters & Action buttons -->
            <div class="p-4 flex flex-row flex-auto w-full items-center justify-between">
                <mat-checkbox [(ngModel)]="showHiddenColumns" (change)="toggleHiddenColumns()">
                    {{ 'showHiddenColumns' | transloco }}
                </mat-checkbox>
                <div class="flex">
                    @if (clipboard.length > 0) {
                        <button mat-raised-button class="mr-4" (click)="pasteQuestions()">
                            <mat-icon [svgIcon]="'mat_solid:content_paste'"></mat-icon>
                            <span class="pl-1">{{ 'pasteQuestions' | transloco }}</span>
                        </button>
                    }
                    <button mat-icon-button [disabled]="!selection.hasValue() || readonly"
                        (click)="removeColumns(selection.selected)" [matTooltip]="'removeColumns' | transloco">
                        <mat-icon svgIcon="mat_outline:delete" class="icon-size-6"></mat-icon>
                    </button>
                </div>
            </div>
            <!-- Main -->
            <div class="flex flex-auto overflow-hidden">
                <!-- Field list -->
                <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                    @if (viewColumns$ | async; as columns) {
                        @if (columns.length > 0) {
                            <!-- Header -->
                            <div class="data-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow dark:shadow-xl text-md font-semibold text-secondary"
                                matSort matSortDisableClear>
                                <mat-checkbox (change)="$event ? masterToggle() : null" [disabled]="readonly"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                                </mat-checkbox>
                                <div>{{ 'name' | transloco }}</div>
                                <div class="hidden xl:block">{{ 'type' | transloco }}</div>
                                <div class="hidden lg:block">{{ 'component' | transloco }}</div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <!-- Rows -->
                            <div [dndDropzone]="['new', 'outside']" [dndEffectAllowed]="'copyMove'" (dndDrop)="drop($event)">
                                <div dndPlaceholderRef class="outline outline-2 outline-dashed bg-primary-100 dark:bg-primary-900 outline-primary h-12 mx-2">
                                </div>
                                @for (column of columns; track column.name; let i = $index) {
                                    <div class="data-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b hover:bg-gray-200 dark:hover:bg-hover"
                                        [class.cursor-pointer]="!columnIsHidden(column)" (click)="openColumn(column)"
                                        [dndDraggable]="column" dndType="outside" [dndEffectAllowed]="'move'" [dndDisableDragIf]="columnIsHidden(column)">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                            [disabled]="columnIsHidden(column) || readonly || !column.detachable"
                                            (change)="$event ? selection.toggle(i) : null"
                                            [checked]="selection.isSelected(i)">
                                        </mat-checkbox>

                                        <!-- Name -->
                                        <div class="flex items-center">
                                            {{ column.name }}
                                            @if (column.type === tableComponentUri) {
                                                <button class="ml-2" mat-icon-button (click)="toggleTableView($event, i)">
                                                    <mat-icon [ngClass]="{ 'text-primary-900 dark:text-primary-200': isExpanded(i) }"
                                                        [svgIcon]="'mat_outline:table_view'"></mat-icon>
                                                </button>
                                            }
                                        </div>
                                        <!-- Type -->
                                        <div class="hidden xl:block truncate">
                                            {{ getType(column) | localize }}
                                        </div>

                                        <!-- View -->
                                        <div class="hidden lg:block truncate">
                                            {{ getView(column) | localize }}
                                        </div>

                                        <!--Info (Errors and warnings)-->
                                        <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                                            @if (column.alert?.length > 0) {
                                                <button mat-icon-button (click)="toggleError($event, column)"
                                                    matTooltip="{{ 'importantInformation' | transloco }}"
                                                    matTooltipClass="my-custom-tooltip">
                                                    <mat-icon [class]="chooseColorIcon(column.alert[0].type)" class="icon-size-5"
                                                        [svgIcon]="chooseAlertIcon(column.alert[0].type)">
                                                    </mat-icon>
                                                </button>
                                            }
                                            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                                                [cdkConnectedOverlayOpen]="column.showError">
                                                <ng-container
                                                    *ngTemplateOutlet="errorTooltip; context: { column } ">
                                                </ng-container>
                                            </ng-template>
                                        </div>

                                        @if (!readonly && !columnIsHidden(column)) {
                                            <mat-icon class="cursor-move" [svgIcon]="'mat_outline:drag_handle'" dndHandle></mat-icon>
                                        }
                                        @if (!readonly) {
                                            <button mat-icon-button (click)="copyItem($event, column)">
                                                <mat-icon [svgIcon]="'mat_outline:content_copy'"></mat-icon>
                                            </button>
                                        }
                                    </div>
                                    <!-- Table View -->
                                    @if (isExpanded(i)) {
                                        <div class="px-8 py-4 border-b">
                                            @if (selectionByFieldName.get(column.name); as tableSelection) {
                                                <!-- Action buttons -->
                                                <div class="px-4 pt-2 pb-4 flex flex-row flex-auto w-full items-center justify-end">
                                                    @if (!readonly && clipboard.length > 0) {
                                                        <button mat-raised-button class="mr-4" (click)="pasteQuestions(column)">
                                                            <mat-icon [svgIcon]="'mat_solid:content_paste'"></mat-icon>
                                                            <span class="pl-1">{{ 'pasteQuestions' | transloco }}</span>
                                                        </button>
                                                    }
                                                    <button mat-icon-button [disabled]="!tableSelection.hasValue() || readonly"
                                                        (click)="removeColumns(tableSelection.selected, column)" [matTooltip]="'removeColumns' | transloco">
                                                        <mat-icon svgIcon="mat_outline:delete" class="icon-size-6"></mat-icon>
                                                    </button>
                                                </div>
                                                @if (column.dtype.column.length > 0) {
                                                    <!-- Header -->
                                                    <div class="data-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow dark:shadow-lg text-md font-semibold text-secondary"
                                                        matSort matSortDisableClear>
                                                        <mat-checkbox (change)="$event ? masterToggle(column) : null" [disabled]="readonly"
                                                            [checked]="tableSelection.hasValue() && isAllSelected(column)"
                                                            [indeterminate]="tableSelection.hasValue() && !isAllSelected(column)">
                                                        </mat-checkbox>
                                                        <div>{{ 'name' | transloco }}</div>
                                                        <div class="hidden xl:block">{{ 'type' | transloco }}</div>
                                                        <div class="hidden lg:block">{{ 'component' | transloco }}</div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                    <!-- Rows -->
                                                    @if (viewColumns$ | async; as columns) {
                                                        <div [dndDropzone]="['new', 'inside']" [dndEffectAllowed]="'copyMove'" (dndDrop)="drop($event, column)">
                                                            <div dndPlaceholderRef class="outline outline-2 outline-dashed bg-primary-100 dark:bg-primary-900 outline-primary h-12 mx-2">
                                                            </div>
                                                            @for (tableColumn of column.dtype.column; track tableColumn.name; let iTable = $index) {
                                                                <div class="data-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b hover:bg-gray-200 dark:hover:bg-hover cursor-pointer"
                                                                    (click)="openColumn(tableColumn, column)"
                                                                    [dndDraggable]="tableColumn" dndType="inside" [dndEffectAllowed]="'move'">
                                                                    <mat-checkbox (click)="$event.stopPropagation()"
                                                                        [disabled]="columnIsHidden(tableColumn) || readonly || !tableColumn.detachable"
                                                                        (change)="$event ? tableSelection.toggle(iTable) : null"
                                                                        [checked]="tableSelection.isSelected(iTable)">
                                                                    </mat-checkbox>

                                                                    <!-- Name -->
                                                                    <div>
                                                                        {{ tableColumn.name }}
                                                                    </div>
                                                                    <!-- Type -->
                                                                    <div class="hidden xl:block truncate">
                                                                        {{ getType(tableColumn) | localize }}
                                                                    </div>

                                                                    <!-- View -->
                                                                    <div class="hidden lg:block truncate">
                                                                        {{ getView(tableColumn) | localize }}
                                                                    </div>

                                                                    <!--Info (Errors and warnings)-->
                                                                    <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                                                                        @if (tableColumn.alert?.length > 0) {
                                                                            <button mat-icon-button (click)="toggleError($event, tableColumn, column)"
                                                                                matTooltip="{{ 'importantInformation' | transloco }}"
                                                                                matTooltipClass="my-custom-tooltip">
                                                                                <mat-icon [class]="chooseColorIcon(tableColumn.alert[0].type)" class="icon-size-5"
                                                                                    [svgIcon]="chooseAlertIcon(tableColumn.alert[0].type)">
                                                                                </mat-icon>
                                                                            </button>
                                                                        }
                                                                        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                                                                            [cdkConnectedOverlayOpen]="tableColumn.showError">
                                                                            <ng-container
                                                                                *ngTemplateOutlet="errorTooltip; context: { column: tableColumn } ">
                                                                            </ng-container>
                                                                        </ng-template>
                                                                    </div>

                                                                    @if (!readonly && !columnIsHidden(tableColumn)) {
                                                                        <mat-icon class="cursor-move" [svgIcon]="'mat_outline:drag_handle'" dndHandle></mat-icon>
                                                                    }
                                                                    @if (!readonly) {
                                                                        <button mat-icon-button (click)="copyItem($event, tableColumn)">
                                                                            <mat-icon [svgIcon]="'mat_outline:content_copy'"></mat-icon>
                                                                        </button>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                    @if (!readonly) {
                                                        <div class="py-3 px-6 md:px-8 m-8 outline outline-2 outline-dashed outline-primary bg-primary-100 dark:bg-primary-900"
                                                            dndDropzone (dndDrop)="drop($event, column)" [dndEffectAllowed]="'copy'" dndDragoverClass="dragover-dropzone">
                                                            {{ 'newQuestionOnTable' | transloco }}
                                                        </div>
                                                    }
                                                } @else {
                                                    <div class="py-3 px-6 md:px-8 outline outline-2 outline-dashed outline-primary bg-primary-100 dark:bg-primary-900"
                                                        dndDropzone (dndDrop)="drop($event, column)" [dndEffectAllowed]="'copy'" dndDragoverClass="dragover-dropzone">
                                                        {{ 'noQuestions' | transloco }}
                                                    </div>
                                                }
                                            }
                                        </div>
                                    }
                                    @if (!readonly) {
                                        <div class="py-3 px-6 md:px-8 m-4 outline outline-2 outline-dashed outline-primary bg-primary-100 dark:bg-primary-900"
                                            dndDropzone (dndDrop)="drop($event, column)" [dndEffectAllowed]="'copy'" dndDragoverClass="dragover-dropzone">
                                            {{ 'newQuestion' | transloco }}
                                        </div>
                                    }
                                }
                            </div>
                        } @else {
                            <div class="py-3 px-6 md:px-8 m-8 outline outline-2 outline-dashed outline-primary bg-primary-100 dark:bg-primary-900"
                                dndDropzone (dndDrop)="drop($event)" [dndEffectAllowed]="'copy'" dndDragoverClass="dragover-dropzone">
                                {{ 'noQuestions' | transloco }}
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #typeList>
    @if (typeFamilies) {
        <div class="p-4 bg-gray-100 dark:bg-gray-900 border-2 border-primary border-solid rounded-md space-y-2">
            <mat-form-field class="w-full mb-2">
                <mat-label>{{ 'selectFamily' | transloco }}</mat-label>
                <mat-select [(ngModel)]="selectedFamily">
                    <mat-select-trigger>
                        {{ (selectedFamily?.caption ?? '') | localize }}
                    </mat-select-trigger>
                    <mat-option [value]="undefined">
                        {{ 'emptyOption' | transloco }}
                    </mat-option>
                    @for (family of familyList; track family.family) {
                        @if (familyForDesign(family)) {
                            <mat-option [value]="family">
                                {{ family.caption | localize }}
                            </mat-option>
                        }
                    }
                </mat-select>
                <mat-hint>{{ 'selectFamilyFirst' | transloco }}</mat-hint>
            </mat-form-field>

            @if (selectedFamily) {
                @for (type of selectedFamily.component; track type.uri) {
                    @if (type.design && ((dtype.uri.startsWith('form') && type.formDesign) || (dtype.uri.startsWith('master') && type.masterDesign) || (dtype.uri.startsWith('taskType') && type.tasktypeDesign))) {
                        <div class="w-full relative flex items-center py-2 px-4 text-base rounded-full cursor-move bg-gray-100 dark:bg-gray-900 hover:bg-hover"
                            [dndDraggable]="type" dndType="new" [dndEffectAllowed]="'copy'">
                            <mat-icon class="text-default" [svgIcon]="type.icon"></mat-icon>
                            <div class="ml-3 leading-5 select-none text-default">
                                {{ type.caption | localize }}
                            </div>
                        </div>
                    }
                }
            }
        </div>
    }
</ng-template>

<ng-template #errorTooltip let-column="column">
    <div class="flex border rounded bg-white dark:bg-slate-900 my-custom-tooltip">
        <button mat-icon-button (click)="column.showError = false"
            class="absolute top-0 right-0 m-1">
            <mat-icon [svgIcon]="'mat_outline:close'" class="icon-size-5"></mat-icon>
        </button>
        <div class="flex flex-col px-3 py-2">
            @for (alert of column.alert; track $index; let i = $index) {
                <div class="flex flex-row mt-2">
                    <mat-icon [class]="chooseColorIcon(alert.type)" class="icon-size-5 mr-1"
                        [svgIcon]="chooseAlertIcon(alert.type)"></mat-icon>
                    <b>{{ alert.type | transloco }}</b>
                </div>
                <div class="flex flex-row mt-2 mb-2">
                    <span>{{ alert.text | localize }} </span>
                    <br>
                </div>
                <div class="flex flex-col w-1/4"></div>
            }
        </div>
    </div>
</ng-template>
